import { useEffect, useId } from "react";
import type { Question } from "../../lib/survey-config";
import type { QuestionProps } from "./types";
import { QuestionHeader } from "./QuestionHeader";

type ShortTextQuestion = Extract<Question, { type: "shortText" }>;

function isValid(q: ShortTextQuestion, v: string): boolean {
  const trimmed = v.trim();
  if (q.required !== false && trimmed.length === 0) return false;
  if (q.maxLength != null && v.length > q.maxLength) return false;
  return true;
}

export function TextQuestion({
  question,
  value,
  onChange,
  onValid,
  autoFocus,
}: QuestionProps<ShortTextQuestion, string>) {
  const id = useId();

  useEffect(() => {
    onValid(isValid(question, value));
  }, [question, value, onValid]);

  return (
    <div className="space-y-4">
      <QuestionHeader
        title={question.title}
        subtitle={question.subtitle}
        required={question.required !== false}
        htmlFor={id}
      />
      <input
        id={id}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={question.placeholder}
        maxLength={question.maxLength}
        autoFocus={autoFocus}
        className="w-full rounded-input border border-border bg-bg-elevated px-4 py-3 text-base outline-none transition focus:border-accent"
      />
    </div>
  );
}
